import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({ allowedRoles, currentRole }) => {
  return allowedRoles.includes(currentRole) ? (
    <Outlet />
  ) : (
    <Navigate to="/unauthorized" replace />
  );
};

export default ProtectedRoute;